import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { MessageListProvider } from "@navigation/screens/MidLevel/MessageScreen/Context/MessageListContext";
import Messages from "@navigation/screens/MidLevel/MessageScreen/Messages";
import { DefaultRootState } from '@reduxLocal/persistState';

/**
 * Extracted MessagesSection component
 * Isolates messageModalVisible selector to prevent parent re-renders
 * Only this component re-renders when modal visibility changes
 */
const MessagesSection: React.FC = () => {
  return (
    <MessageListProvider>
      <Messages />
    </MessageListProvider>
  );
};

export default memo(MessagesSection);

